(function () {

    "use strict";

    function HImageCropperController($scope, modalData, onSave) {
        var self = this;
        self.opts = modalData;
        self.onSave = onSave;

        self.close = function () {
            $scope.$hide();
        };
    };

    HImageCropperController.$inject = ['$scope', 'modalData', 'onSave'];

    angular.module('harriMainApp').controller("hImageCropperController", HImageCropperController);

})
();